import React from 'react';
import cx from 'classnames';

import styles from './NavigationBody.module.scss';

export interface NavigationBodyProps {
  /** Children should contain `Navigation.Group`, `Navigation.Item`, and/or `Navigation.DrillIn`.  */
  children?: React.ReactNode;
  /** Apply CSS class to the container. */
  className?: Parameters<typeof cx>[0];
}

export const NavigationBody: React.FC<NavigationBodyProps> = ({
  children,
  className,
}) => <nav className={cx(styles.navBody, className)}>{children}</nav>;

export default NavigationBody;
export { styles };
